import React from "react";
import { CommunityPropertyCardSlider } from "communities/community-page/_components/community-property-card-slider";

export default function CommunityPropertyCardSliderLoader() {
    // Todo : vérifier si les properties sont dans la communauté sinon les fetch
    return <CommunityPropertyCardSlider />;
}
